import { CheckListItem } from "./checkListItem";
import { useEffect, useState } from "react";
import { CoffeCupIcon, FindItemIcon } from "../../../assets/icons";
import { Button } from "../../../components/button/button";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { TextInput } from "../../../components/textInput/textInput";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import AdminAPI from "../../../api/AdminAPI";
import qs from "qs";

import styles from "./adminCheckList.module.css";
import { Separator } from "../../../components/separator/separator";

import { Text } from "../../../components/text/text";

export const AdminCheckListPage = () => {
    const [items, setItems] = useState([]);
    const [searchField, setSearchField] = useState("");

    const { search } = useLocation();
    const searchParams = qs.parse(search.replace("?", ""));

    const [isDailyTasks, setIsDailyTasks] = useState((searchParams.initialDaily !== undefined) ? searchParams.initialDaily === "true" : true);

    const checklistId = useSelector(state => state.user.adminData.checklistId);

    useEffect(() => {
        if (isDailyTasks) {
            if (checklistId === null) return;
            AdminAPI
                .fetchAdminDailyTasks(checklistId)
                .then(setItems)
                .catch(console.error);
        } else {
            AdminAPI
                .fetchAdminReccurentTasks()
                .then(setItems)
                .catch(console.error);
        }

    }, [checklistId, isDailyTasks]);

    const navigate = useAnimatedNavigate();

    const onDeleteTask = (id) => {
        AdminAPI
            .deleteAdminReccurentTask(id)
            .then(() => {
                setItems(prev => prev.filter(el => el.id !== id));
            })
            .catch(console.error);
    }

    return (
        <>
            <AdminHeader title="Ваши задачи" />
            <TextInput value={searchField} setValue={setSearchField} leftContent={<FindItemIcon />} />

            <div className={styles.view_type_selector}>
                <Button
                    view="thin"
                    type={isDailyTasks ? "primary" : "secondary"}
                    text="Дневные"
                    onClick={() => {
                        setItems([]);
                        setIsDailyTasks(true);
                    }}
                />

                <Button
                    view="thin"
                    type={!isDailyTasks ? "primary" : "secondary"}
                    text="Повторяющиеся"
                    onClick={() => {
                        setItems([]);
                        setIsDailyTasks(false);
                    }}
                />
            </div>

            {
                items.length === 0 &&
                <div className={styles.no_elements_placeholder}>
                    <CoffeCupIcon className={styles.no_elements_icon} />
                    <Text as="div" variant="body" className={styles.no_elements_text} size={16} weight={700}>
                        У Вас еще нет задач.
                    </Text>
                </div>
            }

            {
                items.length > 0 &&
                <div className={styles.check_list_items}>
                    {
                        items.filter(el => el.taskText.toLowerCase().includes(searchField.toLowerCase().trim())).map((item) => (
                            <CheckListItem key={item.id} data={item} setData={setItems} isDailyTasks={isDailyTasks} onDeleteTask={onDeleteTask} />
                        ))
                    }
                </div>
            }

            <Separator />

            <Button
                fixed
                type="primary"
                text="Поставить задачу"
                onClick={() => navigate(`add`)}
            />
        </>
    )
}
